import { Tab, Tabs } from "@vds/tabs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import CameraTab from "./cameraTab";
import CompanionTab from "./companionTab";
// import UnpairedCameraTab from "./unpairedCameraTab";
import "../../../styles/deviceStyle.css";
import { useLocation, useNavigate } from "react-router-dom";
import {
  devicesSelectedTab,
  getAllCameraAndFovsDevices,
  refreshCameraPage,
  showNotificationBanner,
  showCalibrationBanner,
  updateCameraCalibrationStatus,
} from "../../../store/actions";
import { usePaginationReset } from "../../../hooks/usePaginationReset";
import { PAGE_IDENTIFIERS } from "../../../global/constants/tableConstants";
import { hasPermission } from "../../../global/utility/permissionUtils";
import { Notification } from "@vds/notifications";
import NewCameraTab from "./newCameraTab";
import NewUnpairedCameraTab from "./newUnpairedCameraTab";
import { use } from "react";
import {
  NOTIFICATION_TYPES,
  BUTTON_LABELS,
  SUBTITLES,
  TITLES,
  MODAL_LABELS,
  RADIO_OPTIONS,
} from "../../../constants/cameraInfoConstants";
import { checkStreamCalibration } from "../../../global/utility/Utils";
import store from "../../../store";
let tabNameData;
const NewDevices = () => {
  const [notificationBanner, setNotificationBanner] = useState(true);
  const { state } = useLocation();
  const navigate = useNavigate();
  const notificationBannerForStream = state ? state.banner : false;
  const notificationBannerDeviceId = state ? state.deviceId : null;
  const data = useSelector((state) => state.deviceReducer);
  const notificationBannerState = useSelector((state) => state.notificationBanner);
  const calibrationBannerState = useSelector((state) => state.calibrationBanner);
  const showDiscoveredCamerasTab = state?.showDiscoveredCamerasTab || false;
  const cameraCalibrationStatus = state?.cameraCalibrationStatus || false;
  const [activeTab, setActiveTab] = useState(
    showDiscoveredCamerasTab ? "Unpaired Cameras" : (state?.tabName || "Camera")
  );
  const dispatch = useDispatch();

  tabNameData = data.devicesSelected || activeTab;

  useEffect(() => {
    if (showDiscoveredCamerasTab) {
      setActiveTab("Unpaired Cameras");
    }
  }, [showDiscoveredCamerasTab]);

  useEffect(() => {
    if (state?.tabName) {
      setActiveTab(state.tabName);
      navigate(".", { state: { ...state, tabName: undefined }, replace: true });
    }
  }, [state?.tabName]);

  // On mount: reset to page 1 unless returning from a detail page within this module.
  const isFromOwnDetailPage = usePaginationReset([PAGE_IDENTIFIERS.CAMERAS_TAB, PAGE_IDENTIFIERS.COMPANION_TAB, PAGE_IDENTIFIERS.DISCOVERED_CAMERAS_TAB, PAGE_IDENTIFIERS.ASSOCIATED_CAMERAS_TAB]);
  useEffect(() => {
    if (!isFromOwnDetailPage) {
      dispatch(getAllCameraAndFovsDevices());
    }
  }, []);


  useEffect(() => {
    if(notificationBannerForStream) {
      setActiveTab("Camera");
      const onboardingStreamName = data?.fovList?.find(f => f.parentdeviceid === notificationBannerDeviceId)?.name;
       const notificationInfo = {
          type: NOTIFICATION_TYPES.STREAM_CALIBRATION,
          priority: NOTIFICATION_TYPES.INFO,
          data: {
            title: onboardingStreamName ? `${onboardingStreamName} ${TITLES.STREAM_CALIBRATION}` : TITLES.STREAM_CALIBRATION,
            subtitle: SUBTITLES.STREAM_CALIBRATION,
            buttonLabel: BUTTON_LABELS.REFRESH,
            redirectUrl: "",
          },
          isDismissible: false,
          hideCloseButton: false,
          dispatchAction: getAllCameraAndFovsDevices(),
          cameraInfoDispatchAction: refreshCameraPage(true),
          deviceId: notificationBannerDeviceId,
          showNotification: true,
        };
        dispatch(showCalibrationBanner(notificationInfo));
        navigate(".", { state: { ...state, banner: false }, replace: true });

   }

  },[notificationBannerForStream])

  useEffect(() => {
    const bannerInfo = calibrationBannerState?.bannerInfo;
    let pollInterval;

    if (
      bannerInfo?.showNotification &&
      bannerInfo?.type === NOTIFICATION_TYPES.STREAM_CALIBRATION
    ) {
      const deviceExists = data?.cameraList?.some(c => c.id === bannerInfo?.deviceId);
      if (!deviceExists) {
        dispatch(showCalibrationBanner({ showNotification: false }));
        return;
      }

      const isStillCalibrating = checkStreamCalibration(bannerInfo?.deviceId || data?.cameraList || [], data?.fovList || []);
      const hasCalibrationStatus = data?.fovList?.some(f => f.parentdeviceid === bannerInfo?.deviceId && f.fields?.calibration?.status !== undefined);

      if (!isStillCalibrating && hasCalibrationStatus) {
        const completedStreamName = Array.isArray(data?.fovList) ? data.fovList.find(f => f.parentdeviceid === bannerInfo?.deviceId)?.name : undefined;
        dispatch(showCalibrationBanner({ showNotification: false, type: "", priority: "", isDismissible: true }));
        dispatch(showCalibrationBanner({
          showNotification: true,
          type: "Success",
          priority: "success",
          title: TITLES.DEVICE_LIST_CALIBRATION_COMPLETE,
          subtitle: SUBTITLES.STREAM_CALIBRATION_COMPLETE,
          isDismissible: true,
        }));
      } else {
        // Still calibrating - poll device list every 15 seconds to check for status change
        const schedulePoll = () => {
          pollInterval = setTimeout(() => {
            dispatch(getAllCameraAndFovsDevices());
            schedulePoll();
          }, 10000);
        };
        schedulePoll();
      }
    }

    return () => {
      if (pollInterval) clearTimeout(pollInterval);
    };
  }, [data?.fovList, data?.cameraList, calibrationBannerState]);

  const showPermissionsBanner = () => {
    const notificationInfo = {
      type: "No Permission",
      priority: "critical",
      showNotification: true,
    };
    dispatch(showNotificationBanner(notificationInfo));
  };

  const renderContent = () => {
    switch (tabNameData) {
      case "Camera":
        return <NewCameraTab cameraData={data} />;
      case "Companion Devices":
        return <CompanionTab companionData={data} />;
      case "Unpaired Cameras": {
        if (!hasPermission("Cameras", "Create")) {
          showPermissionsBanner();
          return;
        } else {
          return <NewUnpairedCameraTab unpairedCameraData={data} />;
        }
      }
      default:
        return <NewCameraTab cameraData={data} />;
    }
  };
  return (
    <>
      <h4
        className="sasp_vz-nhg-eds-font"
        style={{ fontWeight: "300", fontSize: "32px" }}
      >
        Devices
      </h4>
      <div
        style={{
          width: "730px",
          height: "4",
          backgroundColor: "none",
          padding: "1vh",
        }}
      >
        <Tabs
          orientation="horizontal"
          indicatorPosition="bottom"
          fillContainer={false}
        >
          <Tab
            label={"Cameras"}
            data-testid="devices_camerasTab"
            onClick={() => {
              setActiveTab("Camera");
            }}
            selected={tabNameData === "Camera"}
          />
          <Tab
            label={"Companion Devices"}
            data-testid="devices_companionTab"
            onClick={() => {
              setActiveTab("Companion Devices");
            }}
            selected={tabNameData === "Companion Devices"}
          />
          <Tab
            label={"Discovered Cameras"}
            data-testid="devices_discoveredCamerasTab"
            onClick={() => {
              setActiveTab("Unpaired Cameras");
            }}
            selected={tabNameData === "Unpaired Cameras"}
          />
        </Tabs>
      </div>
      <div>{renderContent()}</div>
    </>
  );
};

export default NewDevices;
